import { createFileRoute, redirect } from '@tanstack/react-router'

import { StudentActivity } from '@/activity/components/StudentActivity/StudentActivity'
import { FEATURE_ACTIVITY_LOG } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/_learning/home/activities')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-activities',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_ACTIVITY_LOG)) {
      throw redirect({ to: '/home' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <StudentActivity />
}
